import * as React from 'react'

const TooltipIcon = (props: any) => {
  return (
    <svg {...props} width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 6C0 2.6748 2.6748 0 6 0C9.3252 0 12 2.6748 12 6C12 9.3252 9.3252 12 6 12C2.6748 12 0 9.3252 0 6ZM5.99805 2.5C5.51172 2.5 5.26855 2.71826 5.26855 3.15479C5.26855 3.59424 5.51172 3.81396 5.99805 3.81396C6.24121 3.81396 6.42285 3.75684 6.54297 3.64258C6.66602 3.52539 6.72754 3.36279 6.72754 3.15479C6.72754 2.71826 6.48438 2.5 5.99805 2.5ZM5.32617 9.33789H6.66602V4.4248H5.32617V9.33789Z'
        fill='#405264'
      />
    </svg>
  )
}

export default TooltipIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/TooltipIcon.tsx